export enum HistoryTabsEnum {
  PARTICIPANTS = "participants",
  FINANCE = "finance",
  WAREHOUSE = "warehouse",
}
